import { render } from "./Login.vue?vue&type=template&id=5b5ab52f&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "@/assets/css/style_form_page.css?vue&type=style&index=0&id=5b5ab52f&lang=css&scoped=true"
import "@/assets/css/style_form_parts.css?vue&type=style&index=1&id=5b5ab52f&lang=css&scoped=true"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5ab52f"]])

export default __exports__